// @file Surface wish arrangement store
import { GroupByTypes } from '@padlet/arvo'
import window from 'bits/global'
import { BLANK_GROUP, Group } from 'bits/surface_posts_grouping_helper'
import { defineStore, storeToRefs } from 'pinia'
import { useSurfaceStore } from 'pinia/surface'
import { useSurfaceSectionsStore } from 'pinia/surface_sections'
import { useSurfaceSettingsStore } from 'pinia/surface_settings'
import { computed } from 'vue'

export const useSurfaceWishArrangementStore = defineStore('surfaceWishArrangement', () => {
  const surfaceVuexStore = window.app?.$store // For gradual conversion to pinia

  const { canUseSections } = storeToRefs(useSurfaceStore())
  const { sortedSections } = storeToRefs(useSurfaceSectionsStore())
  const { isPreviewing, wishGroupBy: previewWishGroupBy } = storeToRefs(useSurfaceSettingsStore())

  const wishGroupBy = computed<GroupByTypes>(() => {
    if (!canUseSections.value) return GroupByTypes.None
    return isPreviewing.value ? previewWishGroupBy.value : surfaceVuexStore?.getters.wishGroupBy
  })
  const sortedGroups = computed<Group[]>(() =>
    wishGroupBy.value === GroupByTypes.Section ? sortedSections.value : [BLANK_GROUP],
  )

  return {
    // getters
    wishGroupBy,
    sortedGroups,
  }
})
